/** Legacy Cognito group names → RBAC slugs (mirrors authapi LEGACY_GROUP_TO_RBAC_SLUG). */
export const LEGACY_GROUP_TO_RBAC_SLUG = {
  admin: "administrator",
  user: "ticket-operator",
};

/** Seed group display names (mirrors halo_contracts GROUP_SEEDS). */
export const GROUP_DISPLAY_NAMES = {
  administrator: "Platform Administrator",
  "user-access-admin": "User & Access Admin",
  "ticket-operator": "Ticket Operator",
  "ffid-operator": "FFID Operator",
  "ticket-viewer": "Ticket Viewer",
  "business-finance": "Business / Finance",
};

/**
 * Normalize Cognito/API group names to RBAC slugs for UI checkboxes and badges.
 * @param {string[] | undefined} groups
 * @returns {string[]}
 */
export function normalizeUserGroupSlugs(groups) {
  const slugs = [];
  for (const name of groups || []) {
    const mapped = LEGACY_GROUP_TO_RBAC_SLUG[name] || name;
    if (mapped === "admin" || mapped === "user") continue;
    if (!slugs.includes(mapped)) slugs.push(mapped);
  }
  return slugs;
}

/**
 * @param {string[]} slugs
 * @param {{ slug: string, display_name?: string }[]} [catalog]
 * @returns {string}
 */
export function formatGroupLabels(slugs, catalog = []) {
  return normalizeUserGroupSlugs(slugs)
    .map((slug) => {
      const fromCatalog = catalog.find((g) => g.slug === slug);
      return fromCatalog?.display_name || GROUP_DISPLAY_NAMES[slug] || slug;
    })
    .join(", ");
}
